var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rentabilidade-component" },
    [
      _c("div", { staticClass: "descricoes" }),
      _c("v-card", { staticClass: "grafico-wrapper", attrs: { flat: "" } }, [
        _c("div", { staticClass: "grafico-desempenho" }, [
          _c("div", { staticClass: "top-grafico" }, [
            _c("div", { staticClass: "top" }, [
              _c("div", { staticClass: "title-grafico" }, [
                _c("span", [_vm._v("Atribuição por Estratégia")])
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "grafico" },
            [
              _c("Bar", {
                attrs: {
                  chartData: _vm.testeObj,
                  chartDataCDI: _vm.arrCDI,
                  options: _vm.options,
                  dataSetCDI: _vm.dadosCDI,
                  plugins: _vm.plugins,
                  label: "Carteira",
                  label2: "Rentabilidade mensal"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }